var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.changes.length
    ? _c("div", { staticClass: "overlay-dialog__changes" }, [
        _vm.text
          ? _c("div", {
              staticClass: "overlay-dialog__text",
              domProps: { innerHTML: _vm._s(_vm.text) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "overlay-dialog__changes-list" },
          _vm._l(_vm.changes, function (change) {
            return _c(
              "li",
              {
                key: change.id,
                staticClass: "overlay-dialog__changes-list-item",
                class: ["overlay-dialog__changes-list-item--" + change.type],
              },
              [
                change.image
                  ? _c("img", {
                      staticClass: "overlay-dialog__changes-list-item-image",
                      attrs: { src: change.image, alt: "Product Image" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  staticClass: "overlay-dialog__changes-list-item-name",
                  domProps: { innerHTML: _vm._s(change.name) },
                }),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }